"use client";
import React, { ReactElement, ReactNode, useState } from "react";
import { ContentResponse } from "../../services/api.response.service";
import Card from "../Card";
import Languages from "../Languages";
import PlusSVG from "../../assets/svg/plus-circle.svg";
import MinusSVG from "../../assets/svg/minus-circle.svg";
import { RouteEndpoints } from "../../services/route.service";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/states";

interface AccordionPanelProps {
  title: string;
  description?: string;
  children?: ReactElement;
  content?: ContentResponse;
  isOpen?: boolean;
  setIsOpen?: () => void;
  handleHeadClick?: () => void;
  subTitle?: string | null;
  showItems?: boolean;
  /** Optional right-aligned row (e.g. video/audio/read badges for parent course). */
  headerBadges?: ReactNode;
}

export default function AccordionPanel({
  isOpen,
  setIsOpen,
  title,
  children,
  content,
  subTitle = null,
  showItems = true,
  handleHeadClick,
  headerBadges,
}: AccordionPanelProps) {
  const [open, setOpen] = useState(isOpen);
  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  function handleClick() {
    if (setIsOpen) {
      setIsOpen();
    } else {
      setOpen(!open);
    }
  }

  return (
    <div
      className={`${
        (isOpen ?? open) ? "bg-white " : "bg-ec-gray"
      } mt-1 border rounded-lg transition-all ease-in-out duration-300`}
    >
      <div
        className={`flex justify-between items-center border-bottom ${(isOpen ?? open) ? "" : ""}`}
        onClick={
          // setIsOpen ??
          () => {
            if (
              // (content.total_topics > 0 || (content.topics && content.topics?.length > 0))
              showItems
            ) {
              handleClick();
            } else {
              handleHeadClick && handleHeadClick();
            }
          }
        }
        style={{
          cursor: "pointer",
          paddingTop: "0.5rem",
          paddingBottom: "0.5rem",
          paddingLeft: "1rem",
          paddingRight: "0",
        }}
      >
        <div className="row col-12">
          <div className="col-11">
            <div className="d-flex flex-wrap align-items-center gap-2 pe-2">
              <h5
                className={
                  `mb-0 ${showItems ? "" : "hover-underline "}` + "course-fw "
                }
              >
                {title}
              </h5>
              {headerBadges}
            </div>

            {(showItems || subTitle) && (
              <span
                title="Total Topics"
                className="d-block mt-1"
                style={{ color: "#3c3c3b" }}
              >
                {subTitle}
              </span>
            )}
          </div>

          <div className="col-1 p-0">
            {showItems && (
              <img
                src={(isOpen ?? open) ? MinusSVG : PlusSVG}
                alt=""
                width={30}
                height={30}
                className="d-grid d-flex gap-1 justify-content-end align-items-end float-end"
                style={{}}
              />
            )}
          </div>
        </div>
        {/*<button className="transition-all ease-in-out duration-300">*/}
        {/*</button>*/}
      </div>

      <div className={`${(isOpen ?? open) ? "mb-4" : ""}`}>
        {(isOpen ?? open) && children}
      </div>
    </div>
  );

  // return  <CourseCardItem item={content}  onClick={setIsOpen ?? (()=> setOpen(!open))} />
}

export function AccordionPanelSecond({
  isOpen,
  setIsOpen,
  title,
  children,
}: AccordionPanelProps) {
  const [open, setOpen] = useState(isOpen);

  return (
    <div>
      <div
        className={`flex items-center ${(isOpen ?? open) ? "mb-4" : ""}`}
        onClick={setIsOpen ?? (() => setOpen(!open))}
      >
        <button className="transition-all ease-in-out duration-300 mr-1.25">
          {/*<Image src={(isOpen ?? open) ? '/minus-circle.svg' : '/plus-circle.svg'} alt='' width={24} height={24} className="w-6 h-6" />*/}
        </button>
        <p className="font-medium text-lg lg:text-xl text-ec-grey-800 cursor-pointer">
          {title}
        </p>
      </div>
      {(isOpen ?? open) && children}
    </div>
  );
}
